// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editOutsidePerson .md-datepicker-input-container{width:140px}", "",{"version":3,"sources":["webpack://./src/components/manage-student/edit-outside-person/edit-outside-person.scss"],"names":[],"mappings":"AAAA,kDAEE,WAAA","sourcesContent":[".editOutsidePerson\n.md-datepicker-input-container {\n  width: 140px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
